import { Injectable } from '@angular/core';

import { ApiBaseService } from "../../common/providers/api-base-service";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Feedback } from "../../common/models/feedback";
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({
    providedIn: 'root'
})
export class FeedbackProvider {
    constructor(
        private api: ApiBaseService,
        private currentUser: CurrentUser,
    ) {}

    public getByType(type:any): Observable<Feedback> {
        return this.api.call('get',`feedback/${type}`, {}, this.currentUser.getAccessToken()).pipe(map((d) => Feedback.fromAPI(d)));
    }

    /**
     * Check whether or not the athlete has answered daily feedback
     *
     * @param organizationId
     * @param athleteUserId
     * @param currentUserId
     */
    public hasAnsweredDailyFeedback(organizationId: number, athleteUserId: number|undefined, currentUserId: number): Observable<boolean> {
        return this.api.call('post',`organizations/${organizationId}/feedback/daily/check`, {userId: athleteUserId ?? currentUserId}, this.currentUser.getAccessToken());
    }
}
